import React, { useEffect } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";

import { BackButton, Button } from "jazasoft";

import AddIcon from "@material-ui/icons/Add";
import { makeStyles } from "@material-ui/styles";
import { Card, CardHeader, Drawer } from "@material-ui/core";

import { isEmpty } from "../../../utils/helpers";
import Table, { NativeTextInput } from "../../../components/Table";

const useStyles = makeStyles(theme => ({
  drawerPaper: {
    width: "78vw",
    maxWidth: 1250,
    minWidth: 900,
    background: "#f8fafc"
  },
  card: {
    margin: 16,
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 4px 18px rgba(0,0,0,0.12)"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: 16,
    background: "#ffffff"
  },
  table: {
    "& th": {
      background: "#f3f6fb",
      fontWeight: 600,
      color: "#34495e",
      border: "1px solid #dfe5ec"
    },
    "& td": {
      border: "1px solid #e3e8ef",
      fontSize: 14,
      height: 42,
      textAlign: "center"
    },
    "& tbody tr:first-child td": {
      background: "#fbfdff",
      fontWeight: 600
    }
  },
  rowCell: {
    padding: "6px 8px",
    fontSize: 13,
    textAlign: "center",
    "&:last-child": {
      padding: "6px 8px",
      fontSize: 13
    }
  },
  footer: {
    position: "sticky",
    bottom: 0,
    background: "#ffffff",
    display: "flex",
    justifyContent: "flex-end",
    gap: 12,
    padding: "14px 18px",
    borderTop: "1px solid #e5e7eb"
  }
}));

const inputStyle = {
  textAlign: "center",
  fontWeight: 500,
  padding: "6px 4px"
};

const SizeBreakupDrawer = props => {
  const classes = useStyles();
  const { open, rows, columns, onClose, onSubmit, onActionComplete } = props;

  const [columnCount, setColumnCount] = React.useState(0);
  const [columnsList, setColumnsList] = React.useState([]);
  const [initialSizeKeys, setInitialSizeKeys] = React.useState([]);
  const [rowsList, setRowsList] = React.useState([]);

  const onChange =
    ({ rowIdx, column }) =>
    e => {
      const value = e?.target?.value || e?.value;
      const dataKey = column.dataKey;

      setRowsList(prev => {
        const newList = [...prev];
        newList[rowIdx] = {
          ...newList[rowIdx],
          [dataKey]: Number(value) || value
        };
        return newList;
      });
    };

  useEffect(() => {
    const dataKeys = columns?.filter(col => !["total", "color", "orderQty"].includes(col.dataKey)).map(col => col.dataKey?.split("_")[1]) || [];

    setColumnCount(dataKeys.length);
    setInitialSizeKeys(dataKeys);
  }, [columns]);

  useEffect(() => {
    if (!isEmpty(columns)) {
      const sizeColumns = Array(columnCount)
        .fill("")
        .map((_, idx) => ({
          dataKey: `size${idx + 1}`,
          title: `Size ${idx + 1}`,
          align: "center",
          element: <NativeTextInput style={inputStyle} onChange={onChange} />
        }));

      const cols = [
        ...sizeColumns,
        {
          dataKey: "orderQty",
          title: "Order Qty",
          align: "center",
          element: <NativeTextInput style={inputStyle} onChange={onChange} />
        }
      ];

      setColumnsList(cols);
    }
  }, [columnCount, columns]);

  useEffect(() => {
    if (!isEmpty(rows)) {
      const firstRow = initialSizeKeys.reduce(
        (acc, key, idx) => ({
          ...acc,
          [`size${idx + 1}`]: key
        }),
        { orderQty: "Order Qty" }
      );

      const rowList = [
        firstRow,
        ...rows.map(row => {
          const rowData = initialSizeKeys.reduce(
            (acc, key, idx) => ({
              ...acc,
              [`size${idx + 1}`]: row[`G1_${key}`]
            }),
            {}
          );

          return {
            ...rowData,
            orderQty: row?.orderQty
          };
        })
      ];

      setRowsList(rowList);
    }
  }, [rows, initialSizeKeys]);

  const addColumns = () => setColumnCount(prev => prev + 1);

  const handleSubmit = () => {
    const keyRow = rowsList[0] || {};
    const valueRow = rowsList[1] || {};

    const serialNumberDataKey = Object.keys(keyRow).filter(k => k.startsWith("size"));

    const sizeBreakupList = serialNumberDataKey
      .map((serialNo, idx) => {
        const size = keyRow[serialNo];
        const qty = Number(valueRow[serialNo]) || 0;

        return {
          serial: idx + 1,
          sizeGroup: "G1",
          size,
          qty
        };
      })
      .filter(sb => !isEmpty(sb.size));

    const orderQty = Number(valueRow.orderQty) || 0;

    onSubmit && onSubmit(sizeBreakupList, orderQty, onActionComplete);
  };

  return (
    <Drawer anchor="right" open={open} classes={{ paper: classes.drawerPaper }} BackdropProps={{ onClick: onClose }}>
      <Card className={classes.card}>
        <div className={classes.header}>
          <CardHeader title="Size Breakup" />
          <Button label="Add Columns" style={{ margin: "10px" }} onClick={addColumns}>
            <AddIcon />
          </Button>
        </div>

        <PerfectScrollbar style={{ width: "100%" }}>
          <Table classes={{ table: classes.table, rowCell: classes.rowCell }} columns={columnsList} rows={rowsList} />
        </PerfectScrollbar>
      </Card>

      <div className={classes.footer}>
        <BackButton onClick={onClose} />
        <Button variant="contained" color="primary" label="Save" onClick={handleSubmit} />
      </div>
    </Drawer>
  );
};

export default SizeBreakupDrawer;
